import type { Tone } from '../../components/ui';
import type { SandboxState } from '../../types/api';

export function stateTone(state: SandboxState): Tone {
  return state === 'failed' ? 'bad' : state === 'waiting' ? 'warn' : state === 'running' ? 'accent' : 'neutral';
}
